import Model, { belongsTo, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BulkAdditionalBookingChargeModel extends Model {
  @belongsTo('booking', { inverse: null, async: false })
  booking!: ModelRegistry['booking'];

  @hasMany('additional-booking-charge', { inverse: null, async: false })
  additionalBookingCharges!: ModelRegistry['additional-booking-charge'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'bulk-additional-booking-charge': BulkAdditionalBookingChargeModel;
  }
}
